import { render, staticRenderFns } from "./ListaRecepcionistas.vue?vue&type=template&id=0dc75ff4&scoped=true"
import script from "./ListaRecepcionistas.vue?vue&type=script&lang=js"
export * from "./ListaRecepcionistas.vue?vue&type=script&lang=js"
import style0 from "./ListaRecepcionistas.vue?vue&type=style&index=0&id=0dc75ff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc75ff4",
  null
  
)

export default component.exports